import { Tier, TIERS } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { SchoolLevel } from '@backrs_ui/grow-ui/src/models/models';

import { MarkersOfSuccess, MarkersOfSuccessItem } from './markersOfSuccess';

const MARKERS_OF_SUCCESS_STRINGS = appStrings.modules.markersOfSuccess;

export const getMarkersOfSuccessStrings = (schoolLevelToCheck: SchoolLevel) => {
  return schoolLevelToCheck === 'high_school'
    ? MARKERS_OF_SUCCESS_STRINGS.highSchoolText
    : MARKERS_OF_SUCCESS_STRINGS.collegeText;
};

/** determines if a school level should be filtered out of view (trade and no_current_enrollment) */
export const shouldSchoolLevelBeFiltered = (schoolLevel: SchoolLevel): boolean => {
  return schoolLevel === 'trade' || schoolLevel === 'no_current_enrollment';
};

/**
 * transforms the school level to the correct format - if the school level is not 'high_school', we default to 'college'
 */
export const transformSchoolLevel = (
  schoolLevel?: SchoolLevel,
): Exclude<
  SchoolLevel,
  'trade' | 'no_current_enrollment' | 'graduate_school' | 'community_college'
> => {
  return schoolLevel === 'high_school' ? 'high_school' : 'college';
};

type GetMarkersOfSuccessItemsProps = Readonly<{
  tier: Tier;
  schoolLevel?: SchoolLevel;
  markersOfSuccess: MarkersOfSuccess;
}>;

/**
 * Get the correct markers of success items based on the tier and school level
 * - We don't have MoS for trade or no_current_enrollment. If a user selects either of these, we just use 'college' as the key
 */
export const getCorrectMarkersOfSuccessItems = ({
  tier,
  schoolLevel,
  markersOfSuccess,
}: GetMarkersOfSuccessItemsProps): Record<string, MarkersOfSuccessItem[]> | null => {
  if (tier === TIERS.SEMISKILLED || tier === TIERS.ENTREPRENEURSHIP) {
    return null;
  }

  // if MoS is anything other than 'high_school', we just use 'college' as the key
  // this is because we don't have MoS for trade or no_current_enrollment
  const schoolLevelKey: SchoolLevel = transformSchoolLevel(schoolLevel);

  return markersOfSuccess[schoolLevelKey][tier];
};
